export default "__VITE_ASSET__DMff8hiY__"